import React from "react";
import useSortingDataByWeek from "./useSortingDataByWeek";

export default function useListVentes() {
	const [data, setData] = React.useState(null);
	const [loadingVente, setLoadingVente] = React.useState(true);
	const [errorData, setErrorData] = React.useState(null);

	const fetchDataVentes = React.useCallback(async () => {
		try {
			const response = await fetch("/api/listVentes");
			if (!response.ok) throw new Error(`Erreur API ${response.status}`);
			const data = await response.json();
			setData(data);
		} catch (err) {
			setErrorData(err.message);
		} finally {
			setLoadingVente(false);
		}
	}, []);

	React.useEffect(() => {
		fetchDataVentes();
	}, [fetchDataVentes]);

	const { ancienneData, actuelleData, futurData } = useSortingDataByWeek(
		data,
		"vente"
	);

	const ancienneVente = ancienneData ? ancienneData : null;
	const venteEnCours = actuelleData ? actuelleData : null;
	const prochaineVente = futurData ? futurData : null;

	return {
		prochaineVente,
		venteEnCours,
		ancienneVente,
		loadingVente,
		errorData,
		fetchDataVentes,
	};
}
